module.exports = __webpack_public_path__ + "img/Distribution1.29c46eb8.png";